import {
    MESSAGES_CLEARED,
    MESSAGES_FETCHED,
    MESSAGES_FETCHING_CHANGED,
    MESSAGES_FILTERS_STATUS_CHANGED,
    MESSAGES_HAS_MORE_CHANGED,
    MESSAGES_MESSAGE_DETAILS_CHANGED,
    MESSAGES_PAGE_CHANGED,
    MESSAGES_PAGINATED,
    MESSAGES_PAGINATING_CHANGED,
    PRIORITY_MESSAGES_FETCHED,
} from '../actions/types';
import { MESSAGE_STATUSES, MESSAGES_PAGE_SIZE } from '../../constants/defaultValues';

const initialState = {
    messagesList: [],
    priorityMessagesList: [],
    isFetching: false,
    isPaginating: false,
    currentPage: 1,
    pageSize: MESSAGES_PAGE_SIZE,
    hasMore: false,
    selectedStatus: MESSAGE_STATUSES[0].status,
    messageDetails: {},
    // requestFilter: false,
    // requestPin: false,
    // request: false,
};

const messageStatusEnum = {
    NEW: 0,
    PIN: 1,
    READ: 2,
};

const messagesReducer = (state = initialState, action) => {
    const { payload } = action;

    switch (action.type) {
        case MESSAGES_FETCHING_CHANGED: {
            return { ...state, isFetching: payload };
        }
        case MESSAGES_PAGINATING_CHANGED: {
            return { ...state, isPaginating: payload };
        }
        case MESSAGES_FETCHED: {
            return { ...state, messagesList: payload, isFetching: false };
        }
        case PRIORITY_MESSAGES_FETCHED: {
            return { ...state, priorityMessagesList: payload };
        }
        case MESSAGES_PAGINATED: {
            return {
                ...state,
                messagesList: [...state.messagesList, ...payload],
                isPaginating: false,
            };
        }
        case MESSAGES_HAS_MORE_CHANGED: {
            return { ...state, hasMore: payload };
        }
        case MESSAGES_PAGE_CHANGED: {
            return { ...state, currentPage: payload };
        }
        case MESSAGES_FILTERS_STATUS_CHANGED: {
            return { ...state, selectedStatus: payload };
        }
        case MESSAGES_CLEARED: {
            return { ...state, messagesList: [] };
        }
        case MESSAGES_MESSAGE_DETAILS_CHANGED: {
            return { ...state, messageDetails: payload };
        }
        default:
            return state;
    }
};

export default messagesReducer;
